import { saveDeactivateEmployeeActions } from "./action";

const initialState = {
  DeactivateDataEmployee: null,
};

const saveDeactiveEmployeeReducer = (state = initialState, action) => {
  switch (action.type) {
    case saveDeactivateEmployeeActions.SAVE_DEACTIVE_EMPLOYEE_DETAILS_SUCCESS:
      return {
        ...state,
        DeactivateDataEmployee: action.payload.data,
      };
    case saveDeactivateEmployeeActions.SAVE_DEACTIVE_EMPLOYEE_DETAILS_ERROR:
      return {
        ...state,
        DeactivateDataEmployee: [],
      };

    default:
      return state;
  }
};

export default saveDeactiveEmployeeReducer;
